/* eslint-disable react/no-unused-prop-types -- Step is a data type, not component props */
import { Clickable, H2, H3, List, P, Section, Strong } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import styled from 'styled-components';

import constants from '../../../../../ahm-constants';
import MakeAClaim from '../make-a-claim';

const StyledSection = styled(Section)`
  padding: 0;
  margin-bottom: 2rem;
`;

const StyledList = styled(List)`
  padding-left: 1rem;
`;

type Step = {
  description: string;
  title: string;
};

const resolutionSteps: Step[] = [
  {
    description:
      'Usually when you have a complaint, we can resolve it immediately on the phone. If we can’t immediately resolve your complaint to your satisfaction, it will be escalated for review by our Internal Dispute Resolution Team (IDR Team) who will acknowledge receipt of your complaint within 1 business day or as soon as practicable.',
    title: 'Initial response',
  },
  {
    description:
      'Our IDR Team will provide you a final written response within 30 calendar days of receiving your complaint. The final response will outline the decision reached and the reasons for the decision.  Where there is a possibility that the 30 calendar day timeframe may not be met (for example if the matter is particularly complex or where there are circumstances outside of our control), we will contact you before the end of the 30 calendar day period advising of the delay and outlining the reasons for the delay.',
    title: 'Internal Dispute Resolution',
  },
  {
    description:
      'In the unlikely event that your complaint is not resolved to your satisfaction by the IDR Team, or a final written response has not been provided within 30 calendar days, you can refer your matter to the Australian Financial Complaints Authority (AFCA) provided your matter is within the scope of the AFCA’s Rules and Operational Guidelines. AFCA is an independent dispute resolution service provided free of charge.',
    title: 'External Dispute Resolution',
  },
];

const ContactUs = () => (
  <StyledSection id="contactUs">
    <H2 variant="marginBottomSpacer10">Contact Us</H2>
    <P>
      For questions relating to an existing policy (purchased <Strong>on or before 30 June 2023</Strong>)
    </P>
    <P>
      <Strong>Phone:</Strong> <Clickable to="tel:1300052589">1300 052 589</Clickable>
    </P>
    <P>8am - 8pm Monday to Friday (AEST)</P>
    <P>
      <Strong>Email:</Strong> <Clickable to="mailto:service@life.ahm.com.au">service@life.ahm.com.au</Clickable>
    </P>
    <P>
      <Strong>Mail:</Strong>
      <br />
      ahm life insurance
      <br />
      Reply Paid 6728
      <br />
      Baulkham Hills NSW 2153
    </P>
    <MakeAClaim />
    <H3 looksLike="h4">Make a complaint</H3>
    <P>
      We hope that you never have a reason to complain, but if you do, we will do our best to work with you to resolve
      it. To lodge a complaint or if you require assistance to lodge a complaint, please contact us using one of the
      following means:
    </P>
    <P>
      <Strong>Phone:</Strong> <Clickable to="tel:1300052589">1300 052 589</Clickable>
    </P>
    <P>
      <Strong>Mail:</Strong>
      <br />
      Dispute Resolution Manager
      <br />
      PO Box 6728
      <br />
      Baulkham Hills NSW 2153
    </P>
    <P>
      <Strong>Email:</Strong> <Clickable to="mailto:service@life.ahm.com.au">service@life.ahm.com.au</Clickable>
    </P>
    <P>Our complaint resolution has three steps:</P>
    <StyledList isOrdered>
      {map(
        ({ title, description }: Step) => (
          <li key={title}>
            <Strong>{title}</Strong>
            <P variant="marginBottomSpacer10">{description}</P>
          </li>
        ),
        resolutionSteps,
      )}
    </StyledList>
    <P>
      <br />
      You may contact AFCA at:
      <br />
      <Strong>Australian Financial Complaints Authority</Strong>
      <br />
      Mail: GPO Box 3, Melbourne VIC 3001
      <br />
      Phone: <Clickable to="tel:1800931678">1800 931 678</Clickable>
      <br />
      Website:{' '}
      <Clickable inNewTab to={constants.URLS.THIRD_PARTY.AUSTRALIAN_FINANCIAL_COMPLAINTS_AUTHORITY}>
        afca.org.au
      </Clickable>{' '}
      <br />
      Email: <Clickable to="mailto:info@afca.org.au">info@afca.org.au</Clickable> <br />
    </P>
  </StyledSection>
);

export default ContactUs;
